import React from "react";
import clsx from "clsx";

import type { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { useAppSelector } from "hooks/redux/useAppSelector";
import TabFilters from "./TabFilters";
import PreRaceTableTabs from "./PreRaceTableTabs";
import { checkCurrentRaceEntriesTableTab } from "../helper";

import useStyles from "./styles";

interface IProps {
  upcomingRaceEntriesQuery: racehorse360.IUpcomingRaceEntryFilter;
}

const PreRaceScreeningSubHeader = (props: IProps) => {
  const { upcomingRaceEntriesQuery } = props;

  const classes = useStyles();
  const selectedTab = useAppSelector(
    state => state.preRaceScreeningPage.selectedTab
  );

  const { isEntryExamsTab } = checkCurrentRaceEntriesTableTab(
    selectedTab.value
  );

  return (
    <div
      className={clsx(classes.subHeader, { entryExamsTab: isEntryExamsTab })}
    >
      <PreRaceTableTabs upcomingRaceEntriesQuery={upcomingRaceEntriesQuery} />
      <TabFilters />
    </div>
  );
};

export default React.memo(PreRaceScreeningSubHeader);
